$('.show-pass').on('click', function (e) {
    var password = $('#password');
    var type = $(password).attr('type');
    if (type == 'password') {
        $(password).attr('type', 'text');
    } else {
        $(password).attr('type', 'password');
    }
});

$('.show-pass2').on('click', function (e) {
    var password = $('#new_password');
    var type = $(password).attr('type');
    if (type == 'password') {
        $(password).attr('type', 'text');
    } else {
        $(password).attr('type', 'password');
    }

});

$('.show-pass1').on('click', function (e) {
    var password = $('#re_password');
    var type = $(password).attr('type');
    if (type == 'password') {
        $(password).attr('type', 'text');
    } else {
        $(password).attr('type', 'password');
    }

});

